import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IGetWatchlistUseCase {
    execute(apiKey: string, profileName: string, token: string, identityToken: string, query: any): Promise<any>;
}

export class GetWatchlistUseCase implements IGetWatchlistUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, profileGuid: string, token: string, identityToken: string, query: any): Promise<any> {
        const result = await this.profileRepository.getWatchlist(apiKey, profileGuid, token, identityToken, query);
        return result.data;
    }
}
